var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChildSeat = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.934 7.383a2.995 2.995 0 0 0 .578-4.197 3.01 3.01 0 0 0-4.205-.58 2.995 2.995 0 0 0-.578 4.197 2.983 2.983 0 0 0 4.205.58Zm2.355-3.94L16.46 16.958c-.196 1.448-1.5 2.455-2.921 2.256l-5.134-.722-.236 1.744 5.134.722c2.362.331 4.543-1.353 4.868-3.76L20 3.684l-1.711-.24Zm-9.352 11.57L4 18.825l1.055 1.419 3.408-2.631 4.338.61c1.42.199 2.725-.809 2.921-2.256l.679-5.014c.146-1.082-.6-2.084-1.66-2.233l-.026-.004a1.888 1.888 0 0 0-.848.085 1.842 1.842 0 0 0-.65.354l-1.38 1.183c-1.046.893-2.82 1.434-4.238 1.217l-.254 1.884c1.625.228 3.627-.388 4.96-1.222l-.433 3.209-2.935-.413Z",
  fill: "#1A1A1A"
})));
export default SvgChildSeat;